import { render, staticRenderFns } from "./AddEditWorkspace.vue?vue&type=template&id=21f90a38&"
import script from "./AddEditWorkspace.vue?vue&type=script&lang=js&"
export * from "./AddEditWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports